import React from 'preact/compat';

export default function FormRequired() {
    return (
        <abbr className='form__required'>*</abbr>
    );
}
